import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Loader from '../Loader';

function dateFormat(date, format = 'YYYY-MM-DD') {
    return moment(date).format(format)
}

class Header extends React.Component {
    render() {
        return (
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Fecha creacion</th>
                    <th>Fecha sorteo</th>
                    <th>Telefono</th>
                    <th>Opciones</th>
                    <th>Cifras</th>
                    <th>Accion</th>
                </tr>
            </thead>
        )
    }
};

class Row extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            color: "verde"
        }
    }
    render() {
        const { data, onRemove, onPDF } = this.props;
        const { color } = this.state;
        // const URL_PRINT = `/prints/lotto`
        // const SEARCH = `?id=${data.id}`
        return <tr>
            <td>{data._id}</td>
            <td>{dateFormat(data.create_at)}</td>
            <td>{data.date.split('T')[0]}</td>
            <td>{data.phone}</td>
            <td>{data.opciones}</td>
            <td>{data.cifras}</td>
            <td>
                {onPDF && (<button
                    onClick={() => { onPDF(data, color) }}
                    className="btn btn-primary btn-flat btn-sm"
                >PDF</button>)}
                <Link
                    to={`generators/${data._id}/edit`}
                    className="btn btn-primary btn-flat btn-sm"
                >Ver</Link>
                {onRemove && (<button
                    onClick={() => { onRemove(data) }}
                    className="btn btn-primary btn-flat btn-sm"
                >Borrar</button>)}
                <div class="form-group">
                    <label>Color</label>
                    <select
                        class="form-control"
                        value={this.state.color}
                        onChange={event => {
                            console.log(event.target.value)
                            this.setState({ color: event.target.value })
                        }}
                    >
                        <option value={'verde'}>Verde</option>
                        <option value={'rojo'}>Rojo</option>
                        <option value={'naranja'}>Naranja</option>
                        <option value={'azul'}>Azul</option>
                    </select>
                </div>
            </td>
        </tr>
    }
}

export default class TableLotto extends React.Component {
    render() {
        const { data, onRemove, onPDF } = this.props
        return (
            <div className="box box-primary col-12">
                <div className="box-body">
                    <table className="table" style={{ width: "100%" }}>
                        <Header />
                        {data && (
                            <tbody>
                                {data.map((lotto, index) => <Row key={index} data={lotto} onRemove={onRemove} onPDF={onPDF} />)}
                            </tbody>
                        )}
                    </table>
                </div>
                <Loader show={this.props.loader} />
            </div>
        )
    }
}

